<div class="mr-wrap">
  <h3 class="mr-heading">{{ heading }}</h3>

  <div class="mode-room">
    <div class="mr-controls">
      <label class="mr-label" for="mr-light">Room Light</label>
      <input id="mr-light" class="mr-slider" type="range" min="0" max="100" step="1"
             [value]="ambient" (input)="onSlide( $any( $event.target ).value )"
             aria-label="Room light">
      <span class="mr-room" [ngSwitch]="roomIcon">
        <svg *ngSwitchCase="'moon'" class="mr-room-icon" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M9.5,1 A7 7 0 1 0 15,10.5 A5.6 5.6 0 0 1 9.5,1 Z"/>
        </svg>
        <svg *ngSwitchCase="'lamp'" class="mr-room-icon" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M5,1 h6 l2.4,6 H2.6 Z"/>
          <path d="M7.2,7 h1.6 v5.5 H7.2 Z"/>
          <path d="M4.5,12.5 h7 a0.8 0.8 0 0 1 0.8 0.8 v0.7 H3.7 v-0.7 a0.8 0.8 0 0 1 0.8-0.8 Z"/>
        </svg>
        <svg *ngSwitchCase="'bulb'" class="mr-room-icon" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M8,0.8 a4.9 4.9 0 0 1 2.6 9 v1.7 H5.4 v-1.7 a4.9 4.9 0 0 1 2.6-9 Z"/>
          <path d="M5.9,12.5 h4.2 v1 H5.9 Z"/>
          <path d="M6.7,14.4 h2.6 v1 H6.7 Z"/>
        </svg>
        <svg *ngSwitchCase="'sun'" class="mr-room-icon" viewBox="0 0 16 16" aria-hidden="true">
          <circle cx="8" cy="8" r="3.4"/>
          <path d="M7.4,0.4 h1.2 v2.4 H7.4 Z M7.4,13.2 h1.2 v2.4 H7.4 Z M0.4,7.4 h2.4 v1.2 H0.4 Z M13.2,7.4 h2.4 v1.2 H13.2 Z M2.6,3.4 l0.8,-0.8 L5.1,4.3 l-0.8,0.8 Z M10.9,11.7 l0.8,-0.8 1.7,1.7 -0.8,0.8 Z M3.4,13.4 l-0.8,-0.8 1.7,-1.7 0.8,0.8 Z M11.7,5.1 l-0.8,-0.8 1.7,-1.7 0.8,0.8 Z"/>
        </svg>
        <span>{{ roomLabel }}</span>
      </span>
    </div>

    <div class="mr-scene" [style.background]="sceneBg">
      <!-- Dark theme pane: a mirror next to a sunny window. -->
      <div class="mr-side">
        <div class="mr-pane mr-pane-dark">
          <div class="mr-chrome">
            <span class="mr-dot"></span><span class="mr-dot"></span><span class="mr-dot"></span>
            <span class="mr-pane-name">Aurora Borealis &middot; Dark</span>
          </div>
          <pre class="mr-code"><code [innerHTML]="code"></code></pre>
          <div class="mr-glare" [style.opacity]="glare" aria-hidden="true"></div>
        </div>
        <span class="mr-status">{{ darkStatus }}</span>
      </div>

      <!-- Light theme pane: the brightest object in a dark room, spilling light. -->
      <div class="mr-side">
        <div class="mr-pane mr-pane-light" [style.box-shadow]="glowShadow">
          <div class="mr-chrome">
            <span class="mr-dot"></span><span class="mr-dot"></span><span class="mr-dot"></span>
            <span class="mr-pane-name">Everest &middot; Light</span>
          </div>
          <pre class="mr-code"><code [innerHTML]="code"></code></pre>
        </div>
        <span class="mr-status">{{ lightStatus }}</span>
      </div>
    </div>

    <p class="mr-decision">
      <strong>Decision:</strong>
      <span class="mr-decision-icon" [ngClass]="'mr-decision-icon--' + decision" aria-hidden="true"></span>
      <span>{{ decisionLabel }}</span>
      <span class="mr-decision-dot" aria-hidden="true">&middot;</span>
      <span class="mr-decision-reason">{{ decisionReason }}</span>
    </p>
  </div>
</div>
